const routes = [
  {
    path: '/',
    name: 'brand',
    redirect: {name: 'organize'}
  },
  {
    path: 'organize',
    name: 'organize',
    component: () => import(/* webpackChunkName: "organize" */ '../views/Organize')
  },
  {
    path: 'measure',
    name: 'measure',
    component: () => import(/* webpackChunkName: "measure" */ '@/views/Measure')
  },
  {
    path: 'assets/:pageUrlId',
    name: 'assetDetail',
    component: () => import(/* webpackChunkName: "assetDetail" */ '@/views/AssetDetail'),
    props: true
  },
  {
    path: 'saved-searches',
    name: 'rules',
    component: () => import(/* webpackChunkName: "savedSearches" */ '@/components/Rules/Rules'),
    meta: {requires: 'searchrule.change_searchrule'}
  },
  {
    path: 'collections',
    name: 'collections',
    component: () => import(/* webpackChunkName: "collections" */ '@/views/Collections')
  },
  {
    path: 'campaigns/:campaignId',
    name: 'campaignDetail',
    component: () => import(/* webpackChunkName: "campaignDetail" */ '@/components/Campaign/CampaignDetail'),
    props: true
  }
]

export default routes
